<template>
  <div class="item" :class="error ? 'invalid-input' : ''">
    <div class="captcha">
      <div class="photo">
        <img v-if="$props.imageSrc" :src="$props.imageSrc" />
        <div v-if="$props.imageSrc" class="refresh">
          <a @click="$emit('reload')"><i class="fas fa-sync-alt"></i></a>
        </div>
        <div v-if="!$props.imageSrc" class="page-loading-icon">
          <i class="fas fa-spinner fa-pulse"></i>
        </div>
      </div>
      <div class="input">
        <!-- <XInput type="captcha" xxx-:value="$props.value" @input="onInput" /> -->
        <XInput type="captcha" :modelValue="modelValue" @input="onInput" />
        <!-- Vue3 ":value" messes-up v-model so we no longer use it. -->

        <!-- <Countdown v-if="$props.imageSrc" :steps="100" @ended="onReload" /> -->
        <!-- countdown somehow re-render parent component. will fixed it.  -->
      </div>
    </div>
    <div class="input-error" :class="$props.error ? 'invalid' : 'hidden'">
      <i class="fas fa-exclamation-triangle"></i>
      {{ error }}
    </div>
  </div>
</template>

<script>
import { store } from "@/store";

export default {
  props: {
    imageSrc: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  methods: {
    onInput(e) {
      // const value = e.target.value;

      store.captcha.touched = true;
      store.captcha.error = null;

      this.$emit("update:modelValue", e.target.value);

      // if (value.length === 5) {
      //   this.onValidate();
      // }
    },
  },
};
</script>
